window.ModalUi = class {
	#instance; // Identificador único para cada instancia del modal
	#options;  // Opciones de configuración para el modal

	$modal = null; // Referencia al modal jQuery
	$slideContainer = null;
	$slide = null;
	step = 1;      // Control del paso actual en el modal
	slideMode = false;
	pluginsLoaded = false;
	#isLoading = false;

	constructor(options = {}) {
		this.#instance = `modal-${Date.now()}`;
		this.#options = this.#mergeOptions(options);

		if(options.slide === true) {
			this.initSlide();
		}
	}

	initSlide() {

		this.slideMode = true;

		// Crear Empty Modal
		this.renderModal('', {}, false);

		this.$slideContainer = $(`<div class="slide-container"></div>`);
		this.$slide = $(`<div class="slide" ></div>`);
		this.$slideContainer.append(this.$slide);
		this.$modal.find('.modal-body').append(this.$slideContainer);
		this.$slide.on('click', "[data-dismiss='slide']", () => {
			this.popSlide();
		});
		this.observe();
	}

	get instance() {
		return this.#instance;
	}

	#mergeOptions(options) {
		const deviceOptions = UtilityHelper.getDevice() === 'smartphone'
			? { mode: 'modal-fullpage', animation: 'slideInUp' }
			: { mode: '', animation: 'fade' };

		const inlineOptions = options.inline
			? { backdrop: false, animation: '' }
			: {};

		return $.extend(
			{
				stack: true,
				cache: true,
				steps: 0,
			},
			deviceOptions,
			inlineOptions,
			options
		);
	}

	loadFromHTML(htmlString = '', data = {}, plugins = true) {
		return this.#processContent(htmlString, data, plugins);
	}

	loadFromTemplate(template_id, data = {}, plugins = true) {

		const script = document.getElementById(template_id);

		if (!script) {
			throw new Error(`Template '${template_id}' does not exist in document`);
		}

		return this.#processContent(script.outerHTML, data, plugins);
	}

	async loadFromServer(template_name, data = {}, http = {}, plugins = true) {

		if (this.#options.cache && document.getElementById(`${template_name}.tpl`)) {
			return await this.loadFromTemplate(`${template_name}.tpl`, data, plugins);
		}

		const [response] = await Promise.all([
			fetch(`/api/template/${template_name}`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(http),
			}),
		]);

		const html = await response.text();

		this.#cacheTemplate(html, template_name);

		return this.#processContent(html, data, plugins);
	}

	/**
	 * Inspecciona el contenido HTML y extrae los datos del script
	 * @param htmlString
	 * @returns {{html: (string|*), scriptData: {containsModalStructure: boolean, loader: (string|string), step: (string|string), title: (string|string), class: (string|string), steps: (string|string)}}}
	 */
	#inspectHtmlTemplate(htmlString) {
		const doc = new DOMParser().parseFromString(htmlString, 'text/html');
		const script = doc.querySelector('script');

		// Verifica si el contenido contiene la estructura de `.modal`
		const content = script ? script.innerHTML : htmlString;
		const containsModalStructure = /class\s*=\s*["'].*\bmodal\b.*["']/.test(content);

		return {
			html: content,
			scriptData: {
				class: script?.getAttribute('modal-class') || '',
				loader: script?.getAttribute('modal-loader') || '',
				title: script?.getAttribute('modal-title') || '',
				steps: script?.getAttribute('modal-steps') || '',
				step: script?.getAttribute('modal-step') || '',
				containsModalStructure
			}
		};
	}

	/**
	 * Carga y renderiza el contenido del modal
	 * @param htmlString
	 * @param data
	 * @param plugins
	 * @returns {*|jQuery|HTMLElement}
	 */
	#processContent(htmlString, data, plugins) {

		if(this.slideMode) {
			return this.renderSlide(htmlString, data, plugins)
		} else {
			return this.renderModal(htmlString, data, plugins);
		}
	}

	async pluginsLoaded() {
		return this.pluginsPromise || Promise.resolve(); // Retorna la promesa de carga o resuelve inmediatamente si ya está cargado
	}

	renderLoading() {
		this.loadFromHTML('', { loader: true });
		this.#isLoading = true;
	}

	renderModal(htmlString, data, plugins) {

		const { html, scriptData } = this.#inspectHtmlTemplate(htmlString);

		// Si no tiene la estructura .modal, usa getWrapperTemplate
		const templateHtml = (scriptData.containsModalStructure || this.#isLoading) ? html : this.#getBaseModalTemplate(html, data);

		const renderedHtml = Twig.twig({ data: templateHtml }).render(data);
		const $renderedHtml = $(renderedHtml);

		if (plugins) {
			this.pluginsPromise = PluginsHandler.load($renderedHtml);
		}

		// Si isLoading es true, el modal ya fue renderizado con un template vacio, this.$modal ya existe y solo se debe actualizar el contenido
		if(this.#isLoading) {
			this.$modal.find('.modal-body').html( $renderedHtml );
			this.#isLoading = false;
		} else {
			this.$modal = $(renderedHtml);
		}

		if (scriptData) {
			if (scriptData.title) this.setTitle(scriptData.title);
			if (scriptData.steps) this.createSteps(scriptData.steps);
			if (scriptData.step) this.setStep(scriptData.step);
		}

		return this.$modal;
	}

	renderSlide(htmlString, data, plugins) {

		const { html, scriptData } = this.#inspectHtmlTemplate(htmlString);


		// Agrega la estructura de slide
		const templateHtml = this.#isLoading ? html : this.#getBaseSlideTemplate(html, data);


		const renderedHtml = Twig.twig({ data: templateHtml }).render(data);
		const $renderedHtml = $(renderedHtml);

		if (scriptData) {
			if (scriptData.title) this.setTitle(scriptData.title);
			if (scriptData.steps) this.createSteps(scriptData.steps);
			if (scriptData.step) this.setStep(scriptData.step);
		}

		if (plugins)
			this.pluginsPromise = PluginsHandler.load($renderedHtml);

		// Si isLoading es true, el slide ya fue renderizado con un template vacio, y solo se debe actualizar el contenido del ultimo slide.
		if(this.#isLoading) {
			this.replaceSlide($renderedHtml);
			this.#isLoading = false;
		}
		else {
			this.pushSlide($renderedHtml);
		}

		return $renderedHtml;

	}

	/**
	 * Cachea el template en el DOM, si existe lo sobreescribe
	 * @param html
	 * @param template_name
	 */
	#cacheTemplate(html, template_name) {
		const scriptId = `${template_name}.tpl`;
		const scriptHTML = html.trim().startsWith('<script') ? html : `<script id="${scriptId}" type="text/html">${html}</script>`;
		const existingScript = document.getElementById(scriptId);

		// Si el script ya existe, lo elimina del DOM
		if (existingScript) {
			existingScript.remove();
		}

		document.body.insertAdjacentHTML('beforeend', scriptHTML);
	}

	/**
	 * Crea el template del modal
	 * @param html
	 * @param data
	 * @returns {string}
	 */
	#getBaseModalTemplate(html, data) {
		return `
			<div class="modal fade" role="dialog">
				<div class="modal-dialog ${this.#options.class || ''} ${data.class || ''}" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<div class="d-flex align-items-center gap-10">
								<div class="modal-steps"></div>
									<h5 class="modal-title">${data.title || ''}</h5>
								</div>
							<button type="button" class="close btn btn-default btn-circle" data-dismiss="modal" aria-label="Close"><i class="fal fa-times"></i></button>
						</div>
						<div class="modal-body">
							${data.loader == true
							?	`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="border-radius: 50%; display: block; margin: 20px auto 40px auto;" width="75px" height="75px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="modal-loader">
									<circle cx="50" cy="50" r="28" stroke-width="7" stroke="var(--primary-color)" stroke-dasharray="43.982297150257104 43.982297150257104" fill="none" stroke-linecap="round">
									<animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
									</circle>
								</svg>` 
							: ''}
							${html}
						</div>
					</div>
				</div>
			</div>`;
	}

	#getBaseSlideTemplate(html, data) {
		return `
			<div class="slide-page">
				${data.loader == true
				?	`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="border-radius: 50%; display: block; margin: 20px auto 100px auto;" width="75px" height="75px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="modal-loader">
						<circle cx="50" cy="50" r="28" stroke-width="7" stroke="var(--primary-color)" stroke-dasharray="43.982297150257104 43.982297150257104" fill="none" stroke-linecap="round">
						<animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
						</circle>
					</svg>`
				: ''}
				${html}
			</div>`;
	}

	createSteps(count = this.#options.steps) {
		const $container = this.$modal.find('.modal-steps').empty();
		for (let i = 0; i < count; i++) {
			$container.append('<i class="fal fa-circle modal-step"></i>');
		}
		this.setStep(this.step);
	}

	setStep(id) {
		this.step = id;
		this.$modal.find('.modal-step').removeClass('fa').addClass('fal');
		this.$modal.find(`.modal-step:nth-child(-n+${id})`).removeClass('fal').addClass('fa');
	}

	setTitle(newTitle) {
		this.$modal.find('.modal-title').html(newTitle);
	}

	async render() {

		this.$modal.attr('id', this.instance);
		if (!this.#options.inline) {
			this.$modal.addClass(this.#options.mode).addClass(this.#options.animation).one("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", () => {
				this.$modal.addClass('animation-off');
			});
			$('body').addClass(this.#options.mode);
			ModalHandler.add(this, this.#options.stack);
		} else {
			this.$modal.addClass('modal-inline');
			this.#options.inline.append(this.$modal);
		}
		await this.show();
		this.$modal.find("[data-dismiss='modal']").on('click', async (e) => {
			e.preventDefault();
			e.stopPropagation();
			await this.hide();
		});
	}

	show() {
		const dfd = $.Deferred();
		this.$modal.on('hidden.bs.modal', (e) => {
			e.currentTarget.remove();
			if (this.#options.callback?.onClose) this.#options.callback.onClose();
			if (!this.#options.inline) ModalHandler.remove(this);
		}).on('shown.bs.modal', () => {
			// unica vez
			this.$modal.off('shown.bs.modal');

			// Agrego la clase modal a mano, a veces al cerrar un modal y abrir otro al instante, no se lo vuelve a setear
			if (!this.#options.inline) $('body').addClass('modal-open');

			// Si es inline debemos quitar la clase modal-open para no bloquear el scrolling
			// No imagino posibilidad en que se abra un modal inline teniendo uno normal abierto, por lo que considero seguro quitar la clase.
			else $('body').removeClass('modal-open');

			// Devolver success de la promesa, el modal ya se esta mostrando...
			dfd.resolve(this);
		}).modal({
			// Deshabilito cerrar con ESC o clickeando afuera.
			// Esto se necesita para no cerrar el modal mientras esta siendo submiteado.
			// backdrop: 'static',
			// keyboard: false,
			show: true,
			...this.#options
		});
		return dfd;
	}

	hide() {
		this.$modal.modal('hide');
		if ("vibrate" in navigator) navigator.vibrate(1);
	}

	getSlide() {
		// Devuelve la diapositiva asignada al modal, si existe
		return this.slide;
	}

	isVisible() {
		return this.$modal && this.$modal.hasClass('show') && this.$modal.is(':visible');
	}

	// -- Slide -- //


	updateHeight() {
		this.$slideContainer.css('height', this.$slideContainer.find('.slide-page').last().innerHeight() );
	}

	// Observa todas las modicaciones al DOM
	// Actualiza el height del contenedor para con el tamaño de la pagina
	observe() {

		const mutationObserver = new MutationObserver(() => {
			if(this.$slideContainer.is(':visible')) {
				this.updateHeight();
			}
		});
		mutationObserver.observe(this.$slideContainer.get(0), {
			childList: true, // Detecta cambios en nodos hijos
			attributes: true, // Detecta cambios en atributos
			subtree: true, // Detecta cambios en todos los descendientes
			characterData: true, // Observa cambios en el contenido textual
		});

	}

	/**
	 * Reemplazar una pagina del slide con nuevo contenido
	 * @param {string|JQuery.element} $newContent puede pasarse un string html o un elemento jquery
	 * @param {*} slideIndex si no se pasa el numero de pagina se va a reemplazar la pagina actualmente vista
	 */
	replaceSlide($newContent, slideIndex) {
		const $slide = this.getSlide(slideIndex);
		$slide?.html($newContent);
	}


	getTotalSlides() {
		return this.$slide.find('.slide-page').length;
	}

	currentSlide() {
		this.$slide.css("--currentSlide");
	}

	/**
	 * Agrega nueva pagina al stack
	 * @param {string|JQuery.element} page puede pasarse un string html o un elemento jquery
	 * @param {bool} animate
	 */
	pushSlide(page, animate = true) {
		if (typeof page == 'string') {
			page = $(page);
		}
		// if (!page.find('.slide-page')) {
		// 	page.wrapAll('<div class="slide-page"></div>');
		// }
		console.log(page);
		this.$slide.append(page);
		this.reloadSlideCounter();

		if (animate)
			this.setLastSlide();
	}

	async popSlide(times = 1) {
		const self = this;

		this.$slide.css('--currentSlide', this.getTotalSlides() - times);

		// actualizar altura contenedor a la nueva pagina
		// debo actualizar aca porque como hay un delay el observer no se dispara
		this.$slideContainer.css('height', this.$slideContainer.find('.slide-page').last().prev().innerHeight() );

		setTimeout(() => { // permitir la animacion

			self.$slide.css('--slideTransition', 0); // anular nuevas animaciones
			self.$slide.children(`:nth-last-of-type(-n+${times})`).remove(); // remover {times} paginas.
			self.reloadSlideCounter(); // Regenerar los contadores. Esto dispararia nuevas animaciones, pero al estar deshabilitadas...
			setTimeout(() => {
				self.$slide.css('--slideTransition', 1); // rehabilitar las animaciones.. damos 10ms de tiempo para realizar el print
			}, 10);

		}, 300);
	}

	reloadSlideCounter() {
		this.$slide.css('--slideCount', this.getTotalSlides());
	}

	setSlide(slideIndex) {
		this.$slide.css('--currentSlide', slideIndex);
	}

	setLastSlide() {
		this.$slide.css('--currentSlide', this.getTotalSlides());
	}

	// Devolver contenido del slide
	// idx de la pagina, sino la ultima
	getSlide(slideIndex) {
		if(slideIndex == undefined)
			return this.$slide.find('.slide-page').last();
		return this.$slide.find('.slide-page').get(slideIndex);
	}
};